import ManualImage from "@/assets/images/manual.svg";
import AutomaticImage from "@/assets/images/automatic.svg";
import i18n from "@/i18n";

export default [
  {
    image: ManualImage,
    text: i18n.t("transmission-types.manual"),
    id: 55100
  },
  {
    image: AutomaticImage,
    text: i18n.t("transmission-types.automatic"),
    id: 55105
  }
];
